import { useEffect } from 'react';
import type React from 'react';

import { getWindowSafe } from '@change-corgi/core/window';

import { ENDORSEMENTS_EXPERIMENT_KEY, EndorsementSection } from 'src/app/shared/components/endorsements';
import { useSessionStorageValue } from 'src/app/shared/hooks/storage';
import { useTrackView } from 'src/app/shared/hooks/tracking';

import { PetitionContent } from './components/PetitionContent';
import { PetitionData } from './components/PetitionData';

export const EditForm: React.FC = () => {
	useTrackView('petition_edit_view');
	const currentWindow = getWindowSafe();

	// Read experiment value from sessionStorage (set by starterDashboardV2)
	const [storedValue] = useSessionStorageValue(ENDORSEMENTS_EXPERIMENT_KEY);
	const isEndorsementsEnabled = storedValue === 'enabled';

	// Handle URL hash scrolling on page load
	useEffect(() => {
		const handleHashScroll = () => {
			if (!currentWindow) return;

			const { hash } = currentWindow.location;
			if (hash) {
				const element = currentWindow.document.querySelector(hash);
				if (element) {
					// Add a small delay to ensure the page is fully rendered
					setTimeout(() => {
						const y = element.getBoundingClientRect().top + currentWindow.pageYOffset - 40; // 40px offset for better visibility
						currentWindow.scrollTo({ top: y, behavior: 'smooth' });
					}, 100);
				}
			}
		};

		// Handle initial hash on page load
		handleHashScroll();

		// Handle hash changes (if user navigates with hash)
		currentWindow?.addEventListener('hashchange', handleHashScroll);

		return () => {
			currentWindow?.removeEventListener('hashchange', handleHashScroll);
		};
	}, [currentWindow]);

	return (
		<>
			<PetitionContent />
			{isEndorsementsEnabled && (
				<div className="mt-10">
					<EndorsementSection />
				</div>
			)}
			<PetitionData />
		</>
	);
};
